import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/contexts/AuthContext";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(username, password);
      if (data.role === "admin") {
        toast.success("Welcome, Admin");
        navigate("/admin");
      } else {
        toast.error("Admin access required");
      }
    } catch (err) {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-slate-900 mb-4">
            <Shield className="h-7 w-7 text-[#FF6347]" />
          </div>
          <h1 className="text-2xl font-extrabold text-slate-900" style={{ fontFamily: "Manrope" }}>
            Admin Portal
          </h1>
          <p className="text-slate-500 text-sm mt-1">Sign in to manage your restaurant</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-sm border border-slate-100 p-6 space-y-4">
          <div>
            <Label className="text-slate-700 text-sm">Username</Label>
            <Input
              data-testid="admin-username-input"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="mt-1.5 h-12 rounded-xl bg-slate-50 border-slate-200"
              placeholder="admin"
              required
            />
          </div>
          <div>
            <Label className="text-slate-700 text-sm">Password</Label>
            <Input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 h-12 rounded-xl bg-slate-50 border-slate-200"
              placeholder="Enter password"
              required
            />
          </div>
          <Button
            data-testid="admin-login-btn"
            type="submit"
            className="w-full h-12 rounded-xl font-bold text-base"
            style={{ backgroundColor: "#FF6347" }}
            disabled={loading}
          >
            {loading ? "Signing in..." : "Sign In"}
            <Lock className="h-4 w-4 ml-2" />
          </Button>
        </form>
      </div>
    </div>
  );
}
